const liftStationWrapper = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  marginTop: '10px',

  height: '100%',
  width: '100%',
  '@media (max-width:600px)': {
    marginLeft: '25px',
  },
};

const liveDataBox = {
  display: 'flex',
  justifyContent: 'center',
};

export { liftStationWrapper, liveDataBox };
